"use client";
import SHeading from "@/components/atoms/SHeading";
import { IMG_STANDARD_ANGLE } from "@/constants";
import { photoboothBenefits } from "@/constants/values";
import Image from "next/image";
import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const PhotoboothMachines = () => {
  const { t } = useTranslation();

  const scrollToContactForm = () => {
    const contactForm = document.getElementById("contactForm");
    if (contactForm) {
      const headerHeight = document.querySelector(".sticky")?.clientHeight || 0;
      const offset =
        contactForm.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }
  };

  return (
    <div className="bg-white flex flex-col items-center md:flex-row justify-center px-4 gap-4 md:gap-8">
      <div className="max-w-[486px] text-center md:text-left">
        <SHeading
          tAlign="center"
          className="leading-normal md:!leading-10 font-bold md:text-3xl text-xl"
        >
          {t("home.photobooth_machines.title")}
        </SHeading>
        <div className="mt-4">
          <SHeading tAlign="center" className="font-bold !leading-normal">
            {t("home.photobooth_machines.subtitle")}
          </SHeading>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5 md:mt-8">
          {photoboothBenefits(t).map((record, index) => (
            <div
              key={`photoboothBenefits-${index}`}
              className="flex flex-col justify-between items-center gap-0 md:gap-2"
            >
              <record.icon />
              <SHeading
                className="!leading-normal h-auto md:min-h-[45px]"
                tAlign="center"
              >
                {record.heading}
              </SHeading>
              <div className="mt-2 text-center text-sm font-light mx-24 md:mx-auto sm:max-w-full md:max-w-[122px] flex-1 flex items-center justify-center">
                <div
                  className="h-auto md:min-h-[120px]"
                  dangerouslySetInnerHTML={{ __html: record.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col items-center justify-center ">
        <div className="pb-4 max-w-[300px]">
          <Image
            src={IMG_STANDARD_ANGLE}
            alt="Photobooth Machine"
            className="w-full"
            width={290}
            height={0}
            priority
          />
        </div>
        <div className="text-center">
          <button className={styles.ctaButton} onClick={scrollToContactForm}>
            {t("home.photobooth_machines.cta_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoboothMachines;
